import React from 'react';
import { Modal } from '../ui/Modal';
import { Logo } from '../layout/Logo';

interface TrialModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubscribe: () => void;
}

export function TrialModal({ isOpen, onClose, onSubscribe }: TrialModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Start Your Free Trial">
      <div className="space-y-4">
        <div className="flex justify-center">
          <Logo />
        </div>

        <div className="text-center">
          <h3 className="mb-2 text-xl font-bold text-on-surface">222fasting Pro</h3>
          <p className="text-sm text-on-surface-variant">
            Unlock full access to Blood Panel and 222Coach
          </p>
        </div>

        <div className="rounded-lg bg-primary/10 p-4">
          <div className="mb-2 flex items-center justify-center">
            <span className="text-4xl font-bold text-primary">7</span>
            <span className="ml-2 text-lg font-medium text-on-surface">days</span>
          </div>
          <p className="text-xs text-center text-on-surface-variant">
            Full access then R150/month
          </p>
        </div>

        <ul className="space-y-2 text-sm text-on-surface-variant">
          <li className="flex items-center gap-2">
            <span className="text-primary">✓</span>
            Full Blood Panel access
          </li>
          <li className="flex items-center gap-2">
            <span className="text-primary">✓</span>
            222Coach AI assistance
          </li>
          <li className="flex items-center gap-2">
            <span className="text-primary">✓</span>
            Advanced protocols (OMAW, TMAW)
          </li>
          <li className="flex items-center gap-2">
            <span className="text-primary">✓</span>
            Progress analytics
          </li>
        </ul>

        <button
          onClick={onSubscribe}
          className="w-full rounded-lg bg-primary px-4 py-3 font-medium text-primary-contrast hover:bg-primary-hover"
        >
          Start 7-Day Free Trial
        </button>

        <p className="text-center text-xs text-on-surface-variant">
          Cancel anytime. No commitment.
        </p>
      </div>
    </Modal>
  );
}
